/** 数据列表 */
<template>
  <div class="table-list">
    <div class="table-title justify-between-center">
      <div class="table-title-text">
        <slot name="titleData" />
      </div>
      <div class="table-btns">
        <slot name="btns" />
      </div>
    </div>

    <el-table
      ref="tableList"
      style="width: 100%"
      :header-cell-class-name="headerCellClassName"
      :data="tableData"
      :border="border"
      stripe
      :span-method="arraySpanMethod"
      :row-key="selectionKey"
      v-loading="loading"
      @select-all="selectionAll"
      @select="handleSelectionChange"
    >
      <el-table-column
        v-if="isSelection"
        type="selection"
        align="center"
        fixed
        :selectable="selectedFun"
        :reserve-selection="isReserveSelection"
      />
      <el-table-column
        v-if="isIndex"
        type="index"
        align="center"
        :index="indexMethod"
        :label="indexLabel"
        width="80"
      />
      <el-table-column
        v-for="(item, index) in labelData"
        :key="index"
        :prop="item.value"
        :width="item.width"
        :min-width="item.minWidth"
        :align="item.align || 'center'"
        :fixed="item.fixed"
        :show-overflow-tooltip="item.showOverflowTooltip"
      >
        <template slot="header">
          <div style="white-space: pre-line">{{ item.label }}</div>
        </template>
        <template slot-scope="scope">
          <slot v-if="item.isSlot" :name="item.value" :scope="scope" />
          <template v-else-if="scope.row.isEdit && item.isEdit">
            <el-input v-model="scope.row[item.value]" class="edit-input" size="small" />
          </template>
          <template v-else-if="Array.isArray(scope.row[item.value])">
            <p v-for="(i, ind) in scope.row[item.value]" :key="ind">
              {{ item.value2 ? i[item.value2] : i }}{{ item.separator }}
            </p>
          </template>
          <template v-else>
            {{ scope.row[item.value] }}
          </template>
        </template>
      </el-table-column>
    </el-table>
    <Page
      :page="page"
      :page-size="pageSize"
      :page-total="pageTotal"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>
<script>
import Page from "../Page";
export default {
  name: "TableList",
  components: {
    Page
  },
  props: {
    value: {
      type: [Array, Object],
      default: () => []
    },
    title: {
      type: String,
      default: "数据列表"
    },
    // 是否带边框
    border: {
      type: Boolean,
      default: false
    },
    // 加载动效
    loading: {
      type: Boolean,
      default: false
    },
    // 是否展示序号
    isIndex: {
      type: Boolean,
      default: true
    },
    // 序号label
    indexLabel: {
      type: String,
      default: "序号"
    },
    // 是否展示多选框
    isSelection: {
      type: Boolean,
      default: false
    },
    // 判断是否可选
    selectedFun: {
      type: Function,
      default: () => {
        return Function;
      }
    },
    // 多选时的关键字
    selectionKey: {
      type: String,
      default: "id"
    },
    // 是否记住上一页选中数据
    isReserveSelection: {
      type: Boolean,
      default: true
    },
    // 是否可以全选
    isCheckAll: {
      type: Boolean,
      default: true
    },
    // 选择框重置
    isSelectRest: {
      type: Boolean,
      default: false
    },
    // 数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 表头
    labelData: {
      type: Array,
      default: () => []
    },

    // 需要合并行的index
    spanMethod: {
      type: Array,
      default: () => []
    },
    // 页码
    page: {
      type: Number,
      default: 1
    },
    // 每页显示条目个数
    pageSize: {
      type: Number,
      default: 15
    },
    // 总条数
    pageTotal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      checkedList: [], // 选中列表
      uncheckedList: [], // 未选中列表
      isIndeterminate: false,
      checkAll: false
    };
  },
  watch: {
    // 监听列表
    tableData: {
      handler(value) {
        if (!this.isCheckAll || this.isSelectRest) {
          this.selectionAll([]);
        }
        // 如果为所有全选,翻页时保持状态
        if (this.checkAll) {
          if (this.uncheckedList.length === 0) {
            this.$nextTick(() => {
              // 这里一定要用$nextTick
              value.forEach(row => {
                if (this.selectedFun(row)) {
                  this.$refs.tableList.toggleRowSelection(row, true);
                } else {
                  this.$refs.tableList.toggleRowSelection(row, false);
                }
              });
            });
          } else {
            this.$nextTick(() => {
              value.forEach(row => {
                for (let i = 0; i < this.uncheckedList.length; i++) {
                  if (
                    !this.selectedFun(row) ||
                    row[this.selectionKey] === this.uncheckedList[i][this.selectionKey]
                  ) {
                    this.$refs.tableList.toggleRowSelection(row, false);
                    break;
                  } else {
                    this.$refs.tableList.toggleRowSelection(row, true);
                  }
                }
              });
              this.setIsAllChecked(false);
            });
          }
        }
      }
    },
    // 监听未选中的数组
    uncheckedList: {
      handler(value) {
        if (!this.isCheckAll) return false;
        this.isIndeterminate = false;
        // 1.未选中数组长度和总数相等,取消选中状态,取消样式
        if (this.checkAll && value.length >= this.pageTotal) {
          this.selectionAll();
        } else if (this.checkAll && value.length >= this.pageSize) {
          this.isIndeterminate = true;
        } else if (this.checkAll && value.length !== 0) {
          this.setIsAllChecked(false);
        }
      }
    },
    // 监听选中数组
    checkedList: {
      handler(value) {
        if (!this.isCheckAll) return false;
        // 选中数组长度等于总数,代表全部选中,取消样式
        if (!this.checkAll && value.length && value.length >= this.pageTotal) {
          this.selectionAll();
        } else if (!this.checkAll && value.length < this.pageTotal) {
          this.setIsAllChecked(false);
        }
      }
    }
  },
  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },

    // 序号排列
    indexMethod(index) {
      index = index + 1 + (this.page - 1) * this.pageSize;
      return index;
    },
    // table全选checkbox的勾选状态
    getIsAllChecked() {
      return this.$refs.tableList.store.states.isAllSelected;
    },
    // table全选checkbox的勾选状态
    setIsAllChecked(type) {
      this.$refs.tableList.store.states.isAllSelected = type;
    },
    // 表头单元格的 className
    headerCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 && this.isIndeterminate) {
        return "is-indeterminate";
      }
    },
    // 列标题 Label 区域渲染
    // renderheader函数得用到el-table-column上，而不是el-table
    renderheader(h, { column }) {
      return h("div", {}, [
        h("div", {}, column.label.split("//")[0]),
        h("div", {}, column.label.split("//")[1])
      ]);
    },
    // 全选
    selectionAll(selection) {
      if (this.isCheckAll) {
        if (this.getIsAllChecked() && !this.isSelectRest && selection.length) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
          this.$refs.tableList.clearSelection();
        }
        this.checkedList = [];
        this.uncheckedList = [];
        this.emitInput([]);
        this.$emit("check_all", this.checkAll);
      } else {
        this.handleSelectionChange(selection);
      }
    },

    // 已选中的row
    handleSelectionChange(selection, row) {
      // 单行选择
      if (this.checkAll) {
        // 判断勾选数据行是选中还是取消
        const selected = selection.length && selection.indexOf(row) !== -1;
        if (selected) {
          // 选中,从未选中数组中去掉
          if (this.uncheckedList.length !== 0) {
            const ind = this.uncheckedList.findIndex(
              v => v[this.selectionKey] === row[this.selectionKey]
            );
            this.uncheckedList.splice(ind, 1);
          }
        } else {
          // 取消,当前取消的行push进去
          this.uncheckedList.push(row);
        }
        this.emitInput(this.uncheckedList.map(v => v[this.selectionKey] * 1));
      } else {
        this.checkedList = selection;
        const optionalVal = selection.filter(v => {
          v[this.selectionKey] = String(v[this.selectionKey]);
          return v[this.selectionKey].indexOf("del") === -1;
        });
        this.emitInput(optionalVal.map(v => v[this.selectionKey] * 1));
      }
    },

    // 合并行
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (!this.spanMethod.length) {
        return false;
      }
      const ind = this.spanMethod.findIndex(i => i === columnIndex);
      if (ind !== -1) {
        if (rowIndex % 2 === 0) {
          return [2, 1];
        } else {
          return [0, 0];
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.table-title {
  font-size: 20px;
  color: #434344;
  margin: 10px 0 20px;

  .table-btns {
    min-width: 100px;
    text-align: right;

    .table-download {
      color: var(--theme-actColor);
      border-bottom: 1px solid #409eff;

      &:hover {
        &::after {
          display: none;
        }
      }
    }
  }
}
::v-deep .el-table {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(10, 3, 5, 0.26);
  border-radius: 13px;
  th {
    background: #1b9cee;
    color: #fff;
    font-weight: normal;
  }
  tr {
    height: 60px;
    border: none;
    color: rgba(51, 51, 51, 1);
    &:nth-child(odd) {
      background: rgba(240, 240, 240, 1);
    }
  }
  td {
    border: none;
  }
}
</style>
